import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { KanbanNullState } from "~/components/KanbanNullState/KanbanNullState";
export const PublicKanbanNullState = /*#__PURE__*/ memo((param)=>{
    let { action } = param;
    return /*#__PURE__*/ _jsx(KanbanNullState, {
        action: action,
        text: "There is no Kanban view available for this board."
    });
});
PublicKanbanNullState.displayName = "PublicKanbanNullState";
